import React from 'react'

function EditProject() {
  return (
    <div>
      Coming soon
    </div>
  )
}

export default EditProject
